import StoredLayout from '../../layouts/StoredLayout'
import SocialMediaButtons from './SocialMediaButtons'
export default StoredLayout(SocialMediaButtons)



// WEBPACK FOOTER //
// ./src/ui-elements/social-media-buttons/index.js